import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {SelectFilterModule} from "../../../../../../../components/common/select-filter/select-filter.module";
import {MedicalRecordSportYearInputComponent} from "./medical-record-sport-year-input.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule,
    ],
    declarations: [
        MedicalRecordSportYearInputComponent,
    ],
    exports: [
        MedicalRecordSportYearInputComponent
    ],
})
export class MedicalRecordSportYearInputModule {
}
